import { render, staticRenderFns } from "./EditDiscount.vue?vue&type=template&id=3ce7ff0c&scoped=true&"
import script from "./EditDiscount.vue?vue&type=script&lang=js&"
export * from "./EditDiscount.vue?vue&type=script&lang=js&"
import style0 from "./EditDiscount.vue?vue&type=style&index=0&id=3ce7ff0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7ff0c",
  null
  
)

export default component.exports